module.exports = __webpack_public_path__ + "img/p4_new04.0fea5ba4.png";